<div class="main-container flex flex-row h-screen overflow-hidden">
  @if (!hideLayout()) {
+    <app-sidebar class="hidden sm:block"></app-sidebar>
+  }
  <main class="flex-1 overflow-y-auto">
    <router-outlet/>
  </main>
  <p-toast position="bottom-right" key="bottom-right" />
   <!-- Dedicated onboarding toast with a button -->
  <p-toast position="bottom-right" key="onboarding" [baseZIndex]="5000">
    <ng-template let-message #message>
      <div class="flex flex-col gap-y-3">
        <span>{{ message.summary }}</span>
        <span class="text-[black] text-sm">{{ message.detail }}</span>
        <p-button 
          size="small"
          label="Reprendre l'onboarding"
          severity="danger"
          (click)="resumeOnboarding()" 
        />
      </div>
    </ng-template>
  </p-toast>
  <p-confirmDialog [style]="{ width: '768px' }"></p-confirmDialog>
</div>

